import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Snackbar } from '@material-ui/core';

const MAIN_SCRIPT = /\/static\/js\/main\.[0-9a-f]+\.chunk\.js/;
const EVERY = 5 * 60 * 1000;

/** The bundle's own entry script in an index.html, or null (the dev server has none). */
export const mainScriptOf = html => {
    const found = (html || '').match(MAIN_SCRIPT);

    return found ? found[0] : null;
};

const running = () => {
    const script = document.querySelector('script[src*="/static/js/main."]');

    return script ? mainScriptOf(script.getAttribute('src')) : null;
};

// A screen on a wall has nobody to press «Оновити», and spectators would read
// the notice; the display and its pairing page stay as they are.
const unattended = pathname => /^\/display(\/|$)/.test(pathname);

/**
 * A NEWER RELEASE IS LIVE (30 Oct 2026: «якщо версія фронта змінилася, то щоб
 * була кнопка оновити»). The server's index.html names the bundle it serves;
 * when that is no longer the bundle this page runs — a release was published
 * (front/scripts/release.js) — a notice offers to reload. Never reloads by
 * itself: a form being filled in is the user's to lose or keep.
 *
 * Checked every five minutes and whenever the tab is shown again.
 */
const NewVersionNotice = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [available, setAvailable] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const skip = unattended(pathname);

    useEffect(() => {
        const mine = running();
        if (skip || !mine || available) {
            return undefined;
        }
        let gone = false;
        const check = () => {
            if (document.hidden) {
                return;
            }
            fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' })
                .then(response => (response.ok ? response.text() : null))
                .then(html => {
                    const served = mainScriptOf(html);
                    if (!gone && served && served !== mine) {
                        setAvailable(true);
                    }
                })
                .catch(() => {});
        };
        const timer = setInterval(check, EVERY);
        document.addEventListener('visibilitychange', check);
        check();

        return () => {
            gone = true;
            clearInterval(timer);
            document.removeEventListener('visibilitychange', check);
        };
    }, [skip, available]);

    return (
        <Snackbar
            action={(
                <>
                    <Button
                        color="secondary"
                        data-testid="new-version-reload"
                        onClick={() => window.location.reload()}
                        size="small"
                    >
                        {t('newVersion.reload')}
                    </Button>
                    <Button
                        color="inherit"
                        onClick={() => setDismissed(true)}
                        size="small"
                    >
                        {t('newVersion.later')}
                    </Button>
                </>
            )}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            data-testid="new-version-notice"
            message={t('newVersion.message')}
            open={available && !dismissed && !skip}
        />
    );
};

export default NewVersionNotice;
